// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-icon[data-v-63c69c9a]{cursor:pointer;height:1.25rem;transition-duration:.15s}.close-icon[data-v-63c69c9a]:hover{opacity:.5}.bg-tassels[data-v-63c69c9a]{background-image:url(https://admin.bubblegumballoons.com/uploads/header_image.jpg);background-position:top;background-repeat:no-repeat}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
